export default {
  StatisticalAnalysis: '统计分析',
  BusinessDataAnalysis: '业务数据分析',
  GatewayServiceMonitor: '网关服务监控',
  NetworkQualityMonitor: '网络质量监控',
  NearlyHour: (hour: number) => `近${hour}小时`,
  SearchGatewayCpePlaceholder: '搜索设备号/设备别名/网关号/分支机构',
  TotalUpStream: '总带宽峰值-上行',
  TotalDownStream: '总带宽峰值-下行',
  Bandwidth: '带宽',
  BandwidthUtilization: '带宽使用率',
  BarChartTitle: '分支机构流量使用（top20）',
  NICThroughput: '网卡吞吐量',
  NetworkCardPacketLoss: '网卡丢包',
  EquipmentLoad: '设备负载',
  CPUUsage: 'cpu使用率',
  MemoryUsage: '内存使用率',
  DiskUsage: '磁盘使用率',
  SearchSourceDevice: '搜索来源设备号/设备别名/网关号/分支机构',
  SearchTargetDevice: '搜索目标设备号/设备别名/网关号/分支机构',
  AllProtocol: '全部协议',
  AlarmList: '告警事件',
  SelectPhysical: '选择物理口',
  PortMonitoring: '接口监控',
  EquipmentMonitoring: '设备监控',
  GatewayDeviceMonitoring: '网关设备监控',
  GatewayPortMonitoring: '网关端口监控',
  BussinessChartTips1: '为保证性能，数据粒度将随查看时间长度相应增加，可能导致不同时间段峰值数据不一致。您可前往',
  BussinessChartTips2: '导出查看明细。',
  PublicNetQualityMonitor: '公网质量监控',
  AddMonitoring: '添加监控',
  AddPublicIPTips: '支持配置10个公网IP，配置后24小时后可查看数据。',
  DeleteMonitorConfirmTitle: '确定删除监控配置？',
  DeleteMonitorConfirmContent: '删除后历史监控数据不会保留',
  SearchPublicIP: '搜索公网IP/备注',
  DuplicateIP: '存在重复的IP',
  SelectInterface: '指定网卡',
  SwitchMonitorEvents: '监控事件',
  Open: '开',
  Close: '关',
}